import { SVG, SVGProps } from './svg'

export function IconLayout1l2r(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 16 16">
      <path d="M0 4c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H1a1 1 0 01-1-1V4zm9 0c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-5a1 1 0 01-1-1V4zm0 6c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-5a1 1 0 01-1-1v-2z" />
    </SVG>
  )
}
